<template>
  <div class="nup-adv-row">
    <div class="nup-adv-row__left">
      <span class="nup-adv-row__threshold">{{ thresholdText }}</span>
    </div>
    <img
      class="nup-adv-row__img"
      :class="'nup-adv-row__img--' + tier.theme"
      :src="cardSrc"
      alt=""
    >
  </div>
</template>

<script lang="ts">
import { computed } from 'vue-demi';
import { findAdvancedThreshold, findAdvancedTierImage, type AdvancedTier } from '../constants/rewards';
import { useNupLang } from '../composables/use-nup-lang';
import { usePageTypeFlag } from '../composables/use-page-type';
const __sfc_main = {};
__sfc_main.props = {
  tier: {
    type: Object as () => AdvancedTier,
    required: true
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  const {
    isPC
  } = usePageTypeFlag();
  const {
    isEn
  } = useNupLang();
  const cardSrc = computed(() => {
    return findAdvancedTierImage(props.tier, isPC.value, isEn.value);
  });
  const thresholdText = computed(() => {
    return findAdvancedThreshold(props.tier, isEn.value);
  });
  return {
    cardSrc,
    thresholdText
  };
};
export default __sfc_main;
</script>

<style scoped>
.nup-adv-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 160px;
}

.nup-adv-row__left {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  padding-left: 48px;
}

.nup-adv-row__threshold {
  font-size: 30px;
  line-height: 1;
  color: #303030;
  letter-spacing: -0.4px;
  white-space: nowrap;
}

.nup-adv-row__img {
  display: block;
  height: auto;
  object-fit: contain;
}

.nup-adv-row__img--gold {
  width: 300px;
}

.nup-adv-row__img--dark {
  width: 370px;
}

.nup-page.is-pc .nup-adv-row {
  min-height: 135px;
}

.nup-page.is-pc .nup-adv-row__left {
  padding-left: 40px;
}

.nup-page.is-pc .nup-adv-row__threshold {
  font-size: 20px;
}

.nup-page.is-h5.is-en .nup-adv-row__threshold {
  color: #000;
  font-family: 'BR Hendrix', Arial, sans-serif;
  font-size: 28px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
  opacity: 0.8;
}

.nup-page.is-pc .nup-adv-row__img--gold {
  width: 300px;
  height: 135px;
}

.nup-page.is-pc .nup-adv-row__img--dark {
  width: 421px;
  height: 135px;
}
</style>
